"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
require("./_styles.scss");
var _styledComponents = require("./styled-components");
var _base = _interopRequireDefault(require("../texts/base"));
var _util = require("../../../util");
var _excluded = ["className", "value", "text", "supplementalText", "superscript", "subText", "dataId"];
var BLOCK_CLASS = 'pf-radio';
var bem = (0, _util.klass)(BLOCK_CLASS);
var RadioButton = function RadioButton(_ref) {
  var className = _ref.className,
    value = _ref.value,
    text = _ref.text,
    supplementalText = _ref.supplementalText,
    superscript = _ref.superscript,
    subText = _ref.subText,
    dataId = _ref.dataId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS, bem('button', !subText ? 'button__no-sub-text' : ''))
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.FormControlLabel, Object.assign({
    control: /*#__PURE__*/_react.default.createElement(_reactComponents.RadioButton, {
      'data-test-id': dataId
    }),
    className: bem('propulsion-radio'),
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, text, supplementalText && /*#__PURE__*/_react.default.createElement(_base.default, {
      as: "span",
      className: bem('supplemental-text')
    }, supplementalText), superscript && /*#__PURE__*/_react.default.createElement(_styledComponents.SuperScript, null, superscript)),
    value: value,
    helperText: subText
  }, props)));
};
RadioButton.propTypes = {
  text: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  supplementalText: _propTypes.default.string,
  superscript: _propTypes.default.string,
  subText: _propTypes.default.string,
  className: _propTypes.default.string,
  dataId: _propTypes.default.string
};
RadioButton.defaultProps = {
  value: '',
  supplementalText: '',
  superscript: '',
  subText: '',
  className: '',
  dataId: ''
};
var _default = RadioButton;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');